export class GlamboxBadge {
  static getJewelName (id) {
    switch (id) {
      case 1: return "Pérola";
      case 2: return "Esmeralda";
      case 3: return "Rubi";
      case 4: return "Safira";
      case 5:
      case 6:
      case 7:
      case 8:
      case 9:
      case 10:
        return "Diamante";
      default:
        return null;
    }
  }

  static getJewelColor (id) {
    switch (id) {
      case 1: return "#ff7da4";
      case 2: return "#66b32b";
      case 3: return "#da0044";
      case 4: return "#393ecd";
      case 5:
      case 6:
      case 7:
      case 8:
      case 9:
      case 10:
        return "#849cf6";
      default:
        return "#747f8b";
    }
  }

  static getJewelSlug (id) {
    switch (id) {
      case 1: return "pearl";
      case 2: return "emerald";
      case 3: return "ruby";
      case 4: return "sapphire";
      case 5:
      case 6:
      case 7:
      case 8:
      case 9:
      case 10:
        return "diamond";
      default:
        return null;
    }
  }
}
